import { Component } from '@angular/core';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-spec-partnerschap',
  templateUrl: './spec-partnerschap.component.html',
  styleUrls: ['./spec-partnerschap.component.scss'],
})
export class SpecPartnerschapComponent {}
